import CourseDetailOfTypeSix from '../feature/Courses/CourseDetailOfTypeSix'

const CourseDetailOfTypeSixPage = () => {
  return <CourseDetailOfTypeSix/>
}

export default CourseDetailOfTypeSixPage